import axios from "axios";
import React, { useEffect, useState } from "react";
import { newHost } from "../../pages/Categories/CategoryProfile";
import { newImageUrl } from "../../pages/Manufacturers/ManufactureProfile";
import defaultImage from "../../assets/svg/defultImage.svg";

import { useNavigate } from "react-router";

import { Accordion, AccordionSummary, AccordionDetails, Stack, Skeleton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
const OrdersProductsCheck = () => {
  const token = sessionStorage.getItem("token");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [filterDate, setFilterDate] = useState(null);

  const getOrders = async () => {
    try {
      const response = await axios.get(
        `${newHost}stuff/get-order-products`,
        {
          headers: { Authorization: `Bearer ${token}` },
            params: {
            ...(filterDate && { date: filterDate }),
          },
        },
      );
      const orders = response.data.data?.data;

      setOrders(orders);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOrders();
  }, [filterDate]);
  const navigte = useNavigate();
  const navigateToProductsCheck = (id) => {
    navigte(`/ordersProductsCheck/confirmCheck/${id}`);
  };
   // ===== Skeleton card matching the Accordion shape =====
  const renderOrderSkeleton = (key) => (
    <div
      key={key}
      className="shadow-sm"
      style={{
        backgroundColor: "#F9F9F9",
        margin: "16px 0",
        padding: "16px",
        borderRadius: "8px",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <div className="d-flex gap-2 align-items-center">
          <Skeleton variant="circular" width={40} height={40} />
        <Skeleton variant="text" width={140} height={32} />
        </div>
        <div style={{ flexGrow: 1 }} />
        <Skeleton variant="circular" width={24} height={24} />
      </Stack>
    </div>
  );
  return (
    <>
      <div className="m-4 min-vh-100">
        <div className="row g-3">
          <div className="col-12" dir="rtl">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DateTimePicker'"]}>
                <DatePicker
                  sx={{ width: "25%" }}
                  className="m-0"
                  format="YYYY,MM,DD"
                  slotProps={{
                    textField: {
                      size: "small",
                      placeholder: "اختار تاريخ الطلب",
                    },
                    field: {
                      clearable: true,
                      onClear: () => setFilterDate(""),
                    },
                  }}
                  value={filterDate ? dayjs(filterDate) : null}
                  onChange={(date) =>
                    setFilterDate(date ? date.format("YYYY-MM-DD") : "")
                  }
                />
              </DemoContainer>
            </LocalizationProvider>

         {loading ? (
            // ===== SKELETON STATE =====
            Array.from({ length: 4 }, (_, i) => renderOrderSkeleton(i))
          ) : orders.length > 0 ? (
              [...orders].reverse().map((order) => (
                <>
                  <Accordion
                    key={order.id}
                    expanded={expandedOrder === order.id}
                    onChange={() =>
                      setExpandedOrder(
                        expandedOrder === order.id ? null : order.id,
                      )
                    }
                    sx={{
                      backgroundColor: "#F9F9F9",
                      my: 2,
                      py: 1,
                      border: "none",
                      outline: "none",
                      "&:before": {
                        display: "none",
                      },
                      "&.Mui-expanded": {
                        boxShadow: "none",
                      },
                    }}
                    className="shadow-sm"
                  >
                    {/* ===== HEADER ===== */}
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <div className="row w-100 align-items-center">
                        <div className="col-12 d-flex align-items-center">
                          <img
                            className="services-images-url mx-2"
                            src={
                              order.order_status?.image_url
                                ? order.order_status?.image_url
                                : defaultImage
                            }
                            alt=""
                          />

                          <span className="fw-bold">{`ORD-#${order.id}`}</span>
                          <span className="mx-2">Order</span>
                        </div>
                      </div>
                    </AccordionSummary>

                    {/* ===== DETAILS ===== */}
                    <AccordionDetails>
                      <div className="border rounded-4 p-4">
                        <ul style={{ listStyle: "square inside" }}>
                          <li>
                            {`اسم العميل: ${
                              order.user?.name ? order?.user?.name : "....."
                            }`}
                          </li>

                          {/* ===== SERVICES LIST ===== */}
                          <li>
                            الخدمات المطلوبة:
                            {order.categories?.map((item) =>
                              item?.subcategories?.map((sub) => (
                                <div
                                  key={sub.id}
                                  className="d-flex align-items-center gap-2 m-0"
                                >
                                  <img
                                    className="services-images-url"
                                    src={
                                      item.icon_url
                                        ? item.slug === "cover"
                                          ? item.icon_url
                                          : `${newImageUrl}${item.icon_url}`
                                        : defaultImage
                                    }
                                    alt=""
                                  />
                                  <p className="m-0">{sub.name}</p>
                                </div>
                              )),
                            )}
                          </li>

                          <li>
                            السعر الكلي:
                            <span className="fw-bold mx-2">
                              {Number(order.total).toLocaleString("en-US")} ج.م
                            </span>
                          </li>

                          <li>{`العنوان: ${order?.address?.area}`}</li>

                          <li>{`الوقت المتوقع: ${order?.scheduled_from} - ${order?.scheduled_to}`}</li>

                          <li>
                            حالة الطلب: {order?.order_status?.label_ar}
                            <img
                              className="services-images-url mx-2"
                              src={
                                order?.order_status?.image_url
                                  ? order.order_status?.image_url
                                  : defaultImage
                              }
                              alt=""
                            />
                          </li>
                        </ul>

                        {/* ===== BUTTON ===== */}
                        {order.status == "assigned" && (
                          <div className="d-flex justify-content-center mt-3">
                            <button
                              onClick={() => navigateToProductsCheck(order.id)}
                              className="btn btn-dark px-5"
                            >
                              عرض المواد المطلوبه
                            </button>
                          </div>
                        )}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </>
              ))
            ) : (
              <>
                <div className="text-center py-5 text-muted">
                  لا توجد طلبات مطابقة للبحث
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrdersProductsCheck;
